import { ChangeDetectorRef, Component, Input } from "@angular/core";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { takeUntil } from "rxjs/operators";
import { HrmLoanDeduct } from "../../models/hrm-loan-deduct.model";
import { HrmLoanToPersonnel } from "../../models/hrm-loan-to-personnel.model";

@Component({
  selector: "ngx-hrm-loan-deduct-form",
  templateUrl: "./hrm-loan-deduct-form.component.html",
  styleUrls: ["./hrm-loan-deduct-form.component.scss"],
})
export class HrmLoanDeductFormComponent extends BaseFormComponent<HrmLoanToPersonnel> {
  public apiName: string = "HrmLoanToPersonnel";
  public label: string = "تسویه وام";
  @Input() selectedModel: HrmLoanDeduct;
  isOk: boolean = false;
  constructor(protected selectorService: SelectorService, protected cd: ChangeDetectorRef) {
    super(selectorService, cd);
  }
  async ngOnInit() {
    this.label = "تسویه وام";
    this.setColumns();
    if (this.currentrow && this.currentrow.Id) {
      this.id = !this.id ? this.currentrow.Id : this.id;
      this.httpCommonService
        .getItem<HrmLoanToPersonnel>(this.apiName, this.id)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(
          (data) => {
            this.model = Object.assign({}, data as HrmLoanToPersonnel);
            this.isNewRow = this.model === undefined;
            this.setdefault();
            this.afterDefult();
            this.selectedModel = <HrmLoanDeduct>{};
            this.setFormGroup(this.selectedModel);
          },
          (error) => this.getFailedHelper(error)
        );
    }
  }
  setColumnAttribute() {
    this.orignalColumns = this.getDetailControlModels("HrmLoanDeducts");
    this.selectedModel = <HrmLoanDeduct>{};
    this.setFormGroup(this.selectedModel);
    this.columns = this.orignalColumns.filter(
      (f) => ((!f.areaName || f.areaName === "default") && f.formVisible) || (f.DetailControlModels && f.DetailControlModels[f.name].length > 0)
    );
    this.columns = this.columns.sort((a, b) => a.order - b.order);
    this.setColumnNumber(this.columns, 3);
    this.isOk = true;
  }
  onCreate($event) {
    this.selectedModel = <HrmLoanDeduct>{};
    this.setFormGroup(this.selectedModel);
  }
  onEdit($event) {
    this.selectedModel = $event;
    this.setFormGroup(this.selectedModel);
  }
  public async save() {
    this.result = this.getDataFromFormGroup();
    this.closeModal();
  }
}
